export const {
    Loading,
    PolCarousel,
    SwipingHand,
    PolSelection,
  } = require('./PolCarousel'),
  Logio = require('./Logio').default,
  BtnGrid = require('./BtnGrid').default,
  Socials = require('./Socials').default,
  TabLink = require('./TabLink').default,
  NavTabLinks = require('./NavTabLinks').default,
  VideoPlayer = require('./VideoPlayer').default,
  SocialNetworkShareButton = require('./Socials').SocialNetworkShareButton,
  ShareButton = require('./ShareButton').default;
